import script from "./MessageTemplatesView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageTemplatesView.vue?vue&type=script&setup=true&lang=ts"

import "./MessageTemplatesView.vue?vue&type=style&index=0&id=6206d0c9&scoped=true&lang=scss"

import exportComponent from "../../../../../home/franc/adereso-bsp-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6206d0c9"]])

export default __exports__